import React from 'react';
import dynamic from "next/dynamic";
import PropTypes from 'prop-types';
import TextArea from '@/bit/components/components.forms.text-area';
import Input from "@/bit/components/components.forms.input";
import Selector from "@/bit/components/components.forms.selector";
import CheckBox from "@/bit/components/components.forms.checkbox";
import Radio from "@/bit/components/components.forms.radio";
import Date from "@/bit/components/components.forms.date";
import CustomLink from "@/bit/components/components.custom-link";
import Text, { TEXT_DISPLAY } from "@/bit/components/components.text";
import { FIELD_TYPES, VALIDATION_TYPES } from './enums.js';

const CmsEditableGroupIcons = dynamic(
  () => import("@/bit/components/components.cms-block.cms-editable-group-icons")
);

const CmsFormField = (props) => {
    const { cmsHandler, alias, blockName, frontalListToDelete, index, parentLocation = 'cms-form-pages-1'} = props;

    const printfield = (field) => {
        let options = null;
        switch(field.typeQuestion) {
            case FIELD_TYPES.TEXTAREA:
                return (<TextArea
                cmsHandler={cmsHandler}
                name={field.nameId}
                label={field.label}
                onBlur={field.handleField.handleInput}
                taggingInfo={{
                    ...field.taggingInfo,
                    componentContent: `textarea-${field.nameId}`,
                }}
                showError={field.error !== ''}
                value={field.value}
                error={field.error}
                maxChars={field.maxChars}
                sendTagging
                autoComplete="nope"
                />)
            case FIELD_TYPES.SELECT:
                try {
                if(typeof props['cms-json-rules-1'] === 'string') {
                    options = props['cms-json-rules-1'].replace(/(\w+):\s*'([^']+)'/g, '"$1": "$2"');
                    options = JSON.parse(options);
                    options = options.map(item => ({...item,field: field.nameId}))
                } else {
                    options = props['cms-json-rules-1']?.map(item => ({...item,field: field.nameId}));
                }} catch (e) {

                }
                return (<Selector
                cmsHandler={cmsHandler}
                name={field.nameId}
                label={field.label}
                onChangeText={() => {}}
                taggingInfo={{
                    ...field.taggingInfo,
                    componentContent: `select-${field.nameId}`,
                }}
                onSelect={field.handleField.handleSelect}
                onBlur={() => {}}
                isSearchable={false}
                type="-basic"
                defaultValue={field.value && {label: field.value}}
                options={options}
                showError={field.error !== ''}
                error={field.error}
                sendTagging
                />);
            case FIELD_TYPES.RADIO:
                try {
                if(typeof props['cms-json-rules-1'] === 'string') {
                    options = props['cms-json-rules-1'].replace(/(\w+):\s*'([^']+)'/g, '"$1": "$2"');
                    options = JSON.parse(options);
                    options = options.map(item => ({...item,field: field.nameId}))
                } else {
                    options = props['cms-json-rules-1']?.map(item => ({...item,field: field.nameId}));
                }} catch (e) {

                }
                return (<Radio
                cmsHandler={cmsHandler}
                name={field.nameId}
                label={field.label}
                taggingInfo={{
                    ...field.taggingInfo,
                    componentContent: `radio-${field.nameId}`,
                }}
                onChange={field.handleField.handleRadio}
                type="-basic"
                value={field.value}
                options={options}
                showError={field.error !== ''}
                error={field.error}
                sendTagging
                />);
            case FIELD_TYPES.DATE:
                debugger;
                return (<Date
                    cmsHandler={cmsHandler}
                    name={field.nameId}
                    label={field.label}
                    taggingInfo={{
                        ...field.taggingInfo,
                        componentContent: `date-${field.nameId}`,
                    }}
                    onChange={field.handleField.handleDate}
                    onBlur={() => {}}
                    type="-basic"
                    value={field.value }
                    showError={field.error !== ''}
                    error={field.error}
                    validation={field.validation}
                    sendTagging
                />)
            case FIELD_TYPES.CHECKBOX:
                return (<CheckBox
                cmsHandler={cmsHandler}
                name={field.nameId}
                onChange={field.handleField.handleCheck}
                taggingInfo={{
                    ...field.taggingInfo,
                    componentContent: `checkbox-${field.nameId}`,
                }}
                value={field.value}
                error={field.error}
                sendTagging
                autoComplete="nope"
                >
                <Text cmsHandler={cmsHandler} {...field['cms-atom-text-2']} display={TEXT_DISPLAY.INLINE} />
                <CustomLink
                    cmsHandler={cmsHandler}
                    {...field['cms-atom-link-1']}
                    taggingInfo={{
                    ...props.taggingInfo,
                    componentContent: field['cms-atom-text-1'].text,
                    }}
                >
                    <Text cmsHandler={cmsHandler} {...field['cms-atom-text-1']} display={TEXT_DISPLAY.INLINE} />
                </CustomLink>
                </CheckBox>)
            case FIELD_TYPES.INPUT:
            default:
                return (<Input
                cmsHandler={cmsHandler}
                name={field.nameId}
                label={field.label}
                onBlur={field.handleField.handleInput}
                taggingInfo={{
                    ...field.taggingInfo,
                    componentContent: `input-${field.nameId}`,
                }}
                value={field.value}
                showError={field.error !== ''}
                error={field.error}
                sendTagging
                autoComplete="nope"
                />)
        }
    }

    const hasCssUnit = typeof props.fieldsColumn === 'string' && /[a-zA-Z%]/.test(props.fieldsColumn);

    return (
        <div className="wrapper-field"
            style={{
                flex: hasCssUnit
                    ? '0 0 100%'
                    : props.fieldsColumn && props.fieldsColumn != 1
                        ? `0 1 calc(${100 / parseInt(props.fieldsColumn)}% - ${((props.fieldsColumn - 1) * 8) / props.fieldsColumn}px)`
                        : '1 1 100%',
                maxWidth: hasCssUnit ? props.fieldsColumn : undefined,
                position: 'relative', padding: '0.25rem 0',
                marginRight: hasCssUnit ? `calc(100% - ${props.fieldsColumn})` : undefined
            }}
        >
            <CmsEditableGroupIcons
            elementProps={{
                ...props,
                editName: "cms-block.cms-form.cms-form-field",
            }}
            deleteProps={{
                index,
                itemIdDotNotation: `${blockName}.${parentLocation}.cms-ml-question-list-1`,
                alias,
                frontalListToDelete
            }}
            visibleTools={{
                hiring: false,
                edit: true,
                deleteItem: true,
            }}
            cmsHandler={cmsHandler}
            />
            <div className="wrapper-question">
                {printfield(props)}
            </div>
        </div>
    )
};

CmsFormField.propTypes = {
    /**
   * {
   *  "info": "Le da el nombre al campo, hay algunos especiales como name, phone, document, email, surname1 que es información de cliente y debe ser nombrado asi",
   *  "kind": "both",
   *  "beautifulName": "Nombre del campo"
   * }
   */
  nameId: PropTypes.string,
  /**
   * {
   *  "info": "Define el tipo de campo, podria se input, checkbox, textArea o select",
   *  "kind": "both",
   *  "beautifulName": "Tipo de campo",
   *  "values": "./enums.js:FIELD_TYPES"
   * }
   */
  typeQuestion: PropTypes.string,
  /**
   * {
   *  "info": "Tipo de validaciones",
   *  "kind": "both",
   *  "beautifulName": "Validación del campo",
   *  "values": "./enums.js:VALIDATION_TYPES"
   * }
   */
  validation: PropTypes.string,
  /**
   * {
   *  "info": "Si el campo es obligatorio",
   *  "kind": "both",
   *  "beautifulName": "Obligatorio"
   * }
   */
  requiredField: PropTypes.bool,
  /**
   * {
   *  "info": "Label de la pregunta",
   *  "kind": "both",
   *  "beautifulName": "Label/Placeholder"
   * }
   */
  label: PropTypes.string,
  /**
   * {
   *  "info": "Maximos caracteres del campo, esto solo aplicaria para los de tipo textarea",
   *  "kind": "both",
   *  "beautifulName": "Caracteres maximos (Solo TextArea)"
   * }
   */
  maxChars: PropTypes.number,
  /**
   * {
   *  "info": "Campos que ha en es",
   *  "kind": "both",
   *  "beautifulName": "columnas de campo"
   * }
   */
  fieldsColumn: PropTypes.number,
  /**
     * {
     *  "info": "Valores del selector",
     *  "kind": "both",
     *  "beautifulName": "Opciones del selector"
     * }
     */
    "cms-json-rules-1": PropTypes.string,
  /**
   * {
   *  "info": "Texto de error mostrado por pantalla",
   *  "kind": "dev",
   *  "beautifulName": "Error"
   * }
   */
  error: PropTypes.string,
  /**
   * {
   *  "info": "Objecto que contiene las funciones para gestionar el guardado de los resultados de los campos",
   *  "kind": "dev",
   *  "beautifulName": "Handle de escritura"
   * }
   */
  handleField: PropTypes.shape({
    handleInput: PropTypes.func,
    handleSelect: PropTypes.func,
    handleCheck: PropTypes.func,
    handleRadio: PropTypes.func,
  }),
  /**
   * {
   *  "info": "Información para el tagueado del componente.",
   *  "kind": "both",
   *  "beautifulName": "Información de tagueado"
   * }
   */
  taggingInfo: PropTypes.object,

};

CmsFormField.defaultProps = {
    typeQuestion: 'input',
    validation: 'notBlank',
    fieldsColumn: 1,
    requiredField: true,
    maxChars: 200,
    "cms-json-rules-1": "[{value: 'ejemplo1', label: 'ejemplo1'}, {value: 'ejemplo2', label: 'ejemplo2'}]",
    error: ''
};

export default CmsFormField;
